import { render, staticRenderFns } from "./mahjongway.vue?vue&type=template&id=7c06a5d3&scoped=true"
import script from "./mahjongway.vue?vue&type=script&lang=js"
export * from "./mahjongway.vue?vue&type=script&lang=js"
import style0 from "./mahjongway.vue?vue&type=style&index=0&id=7c06a5d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c06a5d3",
  null
  
)

export default component.exports